export const getLanguageClass = (text) => {
    if (!text) return 'english-text-bold-info'; // default to English style if text is empty or undefined
    const isBangla = /[\u0980-\u09FF]/.test(text);
    return isBangla ? 'bangla-text-bold-info' : 'english-text-bold-info';
};

// Convert English numbers to Bengali numerals
export const convertToBengali = (num) => {
    const bengaliDigits = ['\u09E6', '\u09E7', '\u09E8', '\u09E9', '\u09EA', '\u09EB', '\u09EC', '\u09ED', '\u09EE', '\u09EF'];
    return String(num).split('').map(digit => bengaliDigits[parseInt(digit)] || digit).join('');
};

// Import images for html2canvas compatibility
import ablLogoImg from '@/theme-assets/images/logo/abl_logo.png';
import ablNameImg from '@/theme-assets/images/logo/abl_name.png';
import ablMotoImg from '@/theme-assets/images/logo/abl_moto.png';


export const replaceUnderscores = (text) => {
    if (!text) return '';
    return String(text).replace(/_/g, ' ');
};

export const numberToWords = (num) => {
    const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const thousands = ['', 'Thousand', 'Million', 'Billion'];

    if (num === 0) return 'Zero';

    let groupIndex = 0;
    let result = '';

    while (num > 0) {
        const group = num % 1000;
        if (group !== 0) {
            result = convertGroup(group, ones, teens, tens) + (thousands[groupIndex] ? ' ' + thousands[groupIndex] : '') + ' ' + result;
        }
        num = Math.floor(num / 1000);
        groupIndex++;
    }

    return result.trim();
};

const convertGroup = (num, ones, teens, tens) => {
    let result = '';

    const hundreds = Math.floor(num / 100);
    if (hundreds > 0) {
        result += ones[hundreds] + ' Hundred ';
    }

    const remainder = num % 100;
    if (remainder >= 20) {
        const ten = Math.floor(remainder / 10);
        const one = remainder % 10;
        result += tens[ten] + (one > 0 ? ' ' + ones[one] : '');
    } else if (remainder >= 10) {
        result += teens[remainder - 10];
    } else if (remainder > 0) {
        result += ones[remainder];
    }

    return result.trim();
};

export const BankSlipTemplate = (bankSlipInfo, qrText) => {
    const { personal, admission, fees, download_at } = bankSlipInfo;
    const today = new Date();
    

    // Bank slip copy headers for different purposes
    const headers = {
        1: 'ব্যাংক কপি',                        // Bank Copy
        2: 'হিসাব বিভাগ',                       // Accounts Department
        3: 'হল / দপ্তর বিভাগ কপি',               // Hall/Office Department Copy
        4: 'ছাত্র / ছাত্রীর কপি'                  // Student's Copy
    };

    // Split name into two lines if too long
    const nameLines = personal.name ? personal.name : ['', ''];
    const name1 = nameLines[0] || '';
    const name2 = nameLines[1] || '';

    // Get fee word representation
    const feeWordLines = fees.total_fee_word || ['', ''];
    const feeWord1 = feeWordLines[0] || '';
    const feeWord2 = feeWordLines[1] || '';

    // Build fees breakdown from individual fee properties
    const feesBreakdown = [
        { name: 'ভর্তি ফি', amount: fees.admission_fee || 0 },
        { name: 'বেতন', amount: fees.tution_fee || 0 },
        { name: 'গ্রন্থাগার ফি', amount: fees.library_fee || 0 },
        { name: 'ল্যাবরেটরী ফি', amount: fees.lab_fee || 0 },
        { name: 'গ্রন্থাগার ই-রিসোর্চ ও ইন্টারনেট সেবা ফি', amount: fees.libcard_fee || 0 },
        { name: 'রেজিস্ট্রেশন ফি', amount: fees.registration_fee || 0 },
        { name: 'মার্কস যাচাই ফি', amount: fees.verification_fee || 0 },
        { name: 'সেশন ফি', amount: fees.session_fee || 0 },
        { name: 'ভর্তি সহায়ক ফি', amount: fees.aassistance_fee || 0 },
        { name: 'রোভার স্কাউট ফি', amount: fees.scout_fee || 0 },
        { name: 'শিক্ষা উন্নয়ন খাত', amount: fees.edication_fee || 0 },
        { name: 'উস ফি', amount: fees.us_fee || 0 },
        { name: 'পরিবহন ফি', amount: fees.transport_fee || 0 },
        { name: 'আই.ডি. কার্ড ফি', amount: fees.idcard_fee || 0 },
        { name: 'বি.এন.সি.সি ফি', amount: fees.bncc_fee || 0 },
        { name: 'চিকিৎসা ফি', amount: fees.medical_fee || 0 }
    ].filter(item => item.amount > 0); // Only show fees with amount > 0

    // Image paths (imported as modules for html2canvas compatibility)
    const studentPhotoSrc = personal.photo;
    const ablLogoSrc = ablLogoImg;
    const ablNameSrc = ablNameImg;
    const ablMotoSrc = ablMotoImg;

    return `
        <div class="bankslip-generator-wrapper">
            <style>
                @import url('https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&family=Tiro+Bangla:ital@0;1&family=Times+Noto+Serif:wght@400;700&display=swap');

                * {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                }

                body {
                    font-size: 10px;
                    line-height: 1.3;
                    color: black;
                    background-color: white;
                    font-family: 'Roboto Condensed', 'Times New Roman', serif;
                }

                /* Disable browser headers and footers in print */
                @page {
                    margin: 0;
                    padding: 0;
                    size: A4 landscape;
                }

                @media print {
                    * {
                        margin: 0 !important;
                        padding: 0 !important;
                    }
                    html, body {
                        margin: 0 !important;
                        padding: 0 !important;
                        background: white !important;
                    }
                    .bankslip-generator-wrapper {
                        margin: 0 !important;
                        padding: 0 !important;
                    }
                }

                .bangla-text { font-family: "Tiro Bangla", serif; font-weight: 400; }
                .bangla-text-bold { font-family: "Tiro Bangla", serif; font-weight: 500; }
                .bangla-text-bold-info { font-family: "Tiro Bangla", serif; font-weight: 600; font-size: 11px; }
                
                .english-text { font-family: "Roboto Condensed", "Times New Roman", sans-serif; font-weight: 400; }
                .english-text-bold { font-family: "Roboto Condensed", "Times New Roman", sans-serif; font-weight: 700; }
                .english-text-bold-info { font-family: "Roboto Condensed", "Times New Roman", sans-serif; font-weight: 600; font-size: 11px; }

                .text-center { text-align: center; }
                .text-right { text-align: right; }
                .text-left { text-align: left; }
                .font-weight-bold { font-weight: bold; }

                .row { display: flex; flex-wrap: wrap; margin: 0; }
                .col { flex: 1 1 25%; padding: 2px; box-sizing: border-box; page-break-inside: avoid; }

                .slip-wrapper {
                    padding: 2px;
                    background: white;
                    display: flex;
                    flex-direction: column;
                }

                .slip-header {
                    text-align: right;
                    margin-bottom: 3px;
                    font-size: 10px;
                }

                .slip-logo-section {
                    display: flex;
                    margin-bottom: 2px;
                    gap: 0;
                    width: 100%;
                }

                .slip-logo-item {
                    flex: 0 0 auto;
                    width: 50px !important;
                    min-width: 50px !important;
                    max-width: 50px !important;
                    text-align: center;
                }

                .slip-logo-center {
                    flex: 1 0 auto;
                    display: flex;
                    flex-direction: column;
                    text-align: center;
                    gap: 2px;
                    padding: 0 8px;
                    min-width: 0;
                }

                .slip-logo-center img {
                    max-width: 90%;
                    height: auto;
                    display: block;
                    margin: 0 auto;
                }

                .slip-logo-center img:first-child {
                    margin-bottom: 2px;
                }

                .slip-logo-center img:nth-child(2) {
                    margin: -3px 0 0 0;
                }

                .slip-logo-center div {
                    font-size: 10px;
                    margin-top: 2px;
                    line-height: 1.2;
                }

                .slip-logo-center p {
                    font-size: 12px;
                    margin: 3px 0;
                }

                .slip-photo-qr {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 5px;
                    gap: 8px;
                }

                .slip-photo {
                    flex: 0 0 auto;
                    width: 90px !important;
                    min-width: 90px !important;
                    max-width: 90px !important;
                }

                .slip-photo img {
                    width: 90px;
                    height: 90px;
                    object-fit: cover;
                    border: 1px solid #999;
                }

                .slip-title {
                    flex: 0 0 36%;
                    text-align: center;
                    
                    font-size: 14px;
                }

                .slip-qr {
                    flex: 0 0 auto;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    left: -22px;
                }

                .slip-qr canvas {
                    max-width: 100%;
                    height: auto;
                }

                /* Responsive adjustments for QR positioning */
                @media screen and (max-width: 1024px) {
                    .slip-qr {
                        left: -18px;
                    }
                }

                @media screen and (max-width: 768px) {
                    .slip-qr {
                        left: -12px;
                    }
                }

                @media screen and (max-width: 480px) {
                    .slip-qr {
                        left: -23px;
                    }
                }

                .slip-field {
                    display: flex;
                    font-size: 10px;
                }

                .slip-field-label {
                    flex: 0 0 40%;
                    min-width: 40%;
                }

                .slip-field-value {
                    flex: 1;
                    border-bottom: 1px dotted #000;
                    padding: 0 2px;
                    min-height: 14px;
                    display: flex;
                    align-items: center;
                }

                .slip-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin: 3px 0;
                    font-size: 10px;
                    display: flex;
                    flex-direction: column;
                    border: 1px solid #999;
                }

                .slip-table-header {
                    display: flex;
                    border-bottom: 2px solid #333;
                    font-weight: bold;
                    background: #f9f9f9;
                }

                .slip-table-row {
                    display: flex;
                    border-bottom: 1px solid #999;
                }

                .slip-table-row.total {
                    border-top: 2px solid #333;
                    border-bottom: none;
                    font-weight: bold;
                    font-size: 10px;
                }

                .slip-table-cell {
                    flex: 1;
                    border-right: 1px solid #999;
                    padding: 3px 4px;
                    text-align: left;
                    display: flex;
                    align-items: center;
                    min-height: 18px;
                }

                .slip-table-cell:last-child {
                    border-right: none;
                    text-align: right;
                    justify-content: flex-end;
                }

                .slip-amount-section {
                    font-size: 10px;
                    margin: 4px 0;
                }

                .slip-amount-line {
                    display: flex;
                    align-items: flex-start;
                }

                .slip-amount-label {
                    flex: 0 0 13%;
                }

                .slip-amount-value {
                    flex: 1;
                    border-bottom: 1px dotted #000;
                }

                .slip-signature-section {
                    display: flex;
                    margin-top: 15px;
                    font-size: 10px;
                    gap: 10px;
                }

                .slip-signature-block {
                    flex: 1;
                    text-align: center;
                    border-top: 1px solid #000;
                    padding-top: 3px;
                }
            </style>

            <div class="page-container" style="page-break-after: always; max-width: 100%; margin: auto;">
                <div class="row">
                    ${[1, 2, 3, 4].map((index) => `
                        <div class="col">
                            <div class="slip-wrapper">
                                <!-- Header -->
                                <div class="slip-header bangla-text-bold">
                                    ${headers[index]}
                                </div>

                                <!-- Logo Section -->
                                <div class="slip-logo-section">
                                    <div class="slip-logo-item">
                                        <img src="${ablLogoSrc}" alt="ABL Logo" style="height: 35px; position: relative; left: 14px;">
                                    </div>
                                    <div class="slip-logo-center" style="position: relative; left:10px;">
                                        <img src="${ablNameSrc}" alt="ABL Name" style="height: 12px;margin-top:3px;">
                                        <img src="${ablMotoSrc}" alt="ABL Moto" style="height: 12px;">
                                        <div class="bangla-text" style="margin-top: 2px; font-size: 12px;">চট্টগ্রাম বিশ্ববিদ্যালয় শাখা</div>
                                    </div>
                                    
                                </div>

                                <!-- Photo and QR Section -->
                                <div class="slip-photo-qr">
                                    <div class="slip-photo">
                                        <img src="${studentPhotoSrc}" alt="Student Photo">
                                    </div>
                                    <div class="slip-title bangla-text">
                                        <span style="position: relative;left:-10px;">ব্যাংক রসিদ</span>
                                    </div>
                                    <div class="slip-qr" id="qrCodeUrl${index}"></div>
                                </div>

                                <!-- Details Section -->
                                <div>
                                    <!-- Memo Receipt and Date (Single Row) -->
                                    <div style="display: flex; gap: 8px; margin-bottom: 2px;">
                                        <!-- Left: Memo Receipt -->
                                        <div class="slip-field" style="flex: 1; margin-bottom: 0; gap: 4px; width: 50%;">
                                            <div class="bangla-text-bold" style="width:33%;">ক্রমিক নং-</div>
                                            <div class="english-text" style="border-bottom: 1px dotted black;text-align: center; width: 66%;">
                                                ${admission.memo_receipt || ''}
                                            </div>
                                        </div>
                                        <!-- Right: Date -->
                                        <div class="slip-field" style="flex: 1; margin-bottom: 0; gap: 4px; width: 50%;">
                                            <div class="bangla-text-bold" style="width:20%;">তারিখ</div>
                                            <div class="english-text" style="border-bottom: 1px dotted black; text-align: center; width: 80%;">
                                                ${download_at}
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Student Name (Left-Right Row) -->
                                    <div style="display: flex;gap:5px;margin-bottom: 3px;">
                                        <div style="width: 26%;">
                                            <div class="bangla-text-bold">ছাত্র / ছাত্রীর নাম</div>
                                        </div>
                                        <div style="width: 73%; display: flex; gap: 5px; border-bottom: 1px dotted #000; justify-content: center;">
                                            <span class="english-text">${name1}</span>
                                            <span class="english-text">${name2}</span>
                                        </div>
                                    </div>

                                    <!-- Registration No and Exam Roll (Left-Right Row) -->
                                    <div style="display: flex; gap: 8px; margin-bottom: 3px;">
                                        <div class="slip-field" style="flex: 1; margin-bottom: 0; gap: 4px; width: 46%;">
                                            <div class="bangla-text-bold" style="width: 52%;">রেজিস্ট্রেশন নং-</div>
                                            <div class="english-text" style="border-bottom: 1px dotted black; text-align: center;width: 46%;">
                                                ${admission.regino || ''}
                                            </div>
                                        </div>
                                        <div class="slip-field" style="flex: 1; margin-bottom: 0; gap: 4px; width: 52%;">
                                            <div class="bangla-text-bold" style="width: 63%;">ভর্তি পরীক্ষার রোলঃ</div>
                                            <div class="english-text" style="border-bottom: 1px dotted black; text-align: center;width: 34%;">
                                                ${admission.exam_roll || ''}
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Course -->
                                    <div style="display: flex; gap: 8px; margin-bottom: 3px;">
                                        <div class="slip-field" style="flex: 1; margin-bottom: 0; gap: 4px;">
                                            <div class="bangla-text-bold" style="width: 11%;">শ্রেণী</div>
                                            <div class="english-text" style="border-bottom: 1px dotted black; text-align: center; width: 88%;">
                                                ${admission.course || ''}
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Department -->
                                    <div style="display: flex; margin-bottom: 3px;">
                                        
                                        <div class="slip-field" style="flex: 1; margin-bottom: 0;gap:4px;">
                                            <div class="bangla-text-bold" style="width: 11%;">বিভাগ</div>
                                            <div class="english-text" style="border-bottom: 1px dotted black; text-align: center; width: 88%;">
                                                ${fees.department_name || ''}
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Year and Session (Left-Right Row) -->
                                    <div style="display: flex; gap: 8px;">
                                        <div class="slip-field" style="flex: 1; margin-bottom: 0;gap:4px; width: 40%;">
                                            <div class="bangla-text-bold" style="width: 11%;">বর্ষ</div>
                                            <div class="english-text" style="border-bottom: 1px dotted black; text-align: center; width: 88%;">
                                                1<sup>st</sup> Year
                                            </div>
                                        </div>
                                        <div class="slip-field" style="flex: 1; margin-bottom: 0;gap:5px; width: 60%;">
                                            <div class="bangla-text-bold" style="width: 15%;">সেশন</div>
                                            <div class="english-text" style="border-bottom: 1px dotted black; text-align: center; width: 83%;">
                                                ${admission.session || ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Fee Table -->
                                <div class="slip-table">
                                    <div class="slip-table-header">
                                        <div class="slip-table-cell bangla-text-bold" style="flex: 0 0 10%;">ক্রঃ নং</div>
                                        <div class="slip-table-cell bangla-text-bold" style="flex: 0 0 60%;">বিবরণ</div>
                                        <div class="slip-table-cell bangla-text-bold" style="flex: 0 0 30%; text-align: right;">টাকা</div>
                                    </div>
                                    ${feesBreakdown.map((item, idx) => `
                                        <div class="slip-table-row">
                                            <div class="slip-table-cell english-text" style="flex: 0 0 10%; text-align: center;">${convertToBengali(idx + 1)}</div>
                                            <div class="slip-table-cell bangla-text" style="flex: 0 0 60%;">${item.name || ''}</div>
                                            <div class="slip-table-cell english-text" style="flex: 0 0 30%; text-align: right;">${ item.amount ? item.amount.toFixed(2) : '0.00'}</div>
                                        </div>
                                    `).join('')}
                                    <div class="slip-table-row total" style="font-size: 10px;">
                                        <div class="slip-table-cell bangla-text-bold" style="flex: 0 0 10%;"></div>
                                        <div class="slip-table-cell bangla-text-bold" style="flex: 0 0 60%;">মোট</div>
                                        <div class="slip-table-cell english-text-bold" style="flex: 0 0 30%; text-align: right;">${ fees.total_fee_number ? fees.total_fee_number.toFixed(2) : '0.00'}</div>
                                    </div>
                                </div>

                                <!-- Amount in Words -->
                                <div class="slip-amount-section">
                                    <div class="slip-amount-line">
                                        <div class="slip-amount-label bangla-text-bold" style="padding: 2px 0;font-size: 10px;">কথায়:</div>
                                        <div class="slip-amount-value english-text" style="display: flex; gap: 4px; justify-content: center;">
                                            <span>${feeWord1}</span>
                                            <span>${feeWord2}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Signature Section -->
                                <div style="font-size: 10px;">
                                    <!-- Student Signature Row -->
                                    <div style="display: flex; margin:6px 0;gap: 8px;height: 15px;">
                                        <div style="flex: 0 0 30%;">
                                            <span class="bangla-text-bold" style="padding: 3px 0;">ছাত্র / ছাত্রীর স্বাক্ষর</span>
                                        </div>
                                        <div style="flex: 1; border-bottom: 1px dotted #000;"></div>
                                    </div>

                                    <!-- Bank Officer Signature Row -->
                                    <div style="display: flex; margin:6px 0;gap: 8px; height: 14px;">
                                        <div style="flex: 0 0 33%;">
                                            <span class="bangla-text-bold" style="padding: 3px 0;">ব্যাংক কর্মকর্তার স্বাক্ষর</span>
                                        </div>
                                        <div style="flex: 1; border-bottom: 1px dotted #000;"></div>
                                    </div>
                                    

                                    <!-- Payment Date and Officer Row -->
                                    <div style="display: flex; gap: 8px; min-height: 25px;">
                                        <!-- Payment Date Section -->
                                        <div style="flex: 0 0 40%; display: flex; flex-direction: column; justify-content: space-between;">
                                            <!-- Writing Space -->
                                            <div style="flex: 1; border-bottom: 1px dotted #000; min-height: 25px;"></div>
                                            <!-- Label -->
                                            <div style="text-align: center; padding-top: 3px;">
                                                <span class="bangla-text-bold">টাকা জমা দানের তারিখ</span>
                                            </div>
                                        </div>
                                        
                                        <div style="flex: 0 0 10%;"></div>
                                        
                                        <!-- Officer/Cashier Section -->
                                        <div style="flex: 0 0 45%; display: flex; flex-direction: column; justify-content: space-between;">
                                            <!-- Signature Space -->
                                            <div style="flex: 1; border-bottom: 1px solid #000; min-height: 25px; margin-bottom: 3px;"></div>
                                            <!-- Label -->
                                            <div style="text-align: center;">
                                                <span class="bangla-text-bold">অফিসার/ক্যাশিয়ার</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `).join('')}
                </div>
            </div>
        </div>
    `;
};
